import Box from '@mui/material/Box';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import UiText from '../shared/Typography/UiText';

type StudyDetailList = {
  label: Field<string>;
  value: Field<string>;
};

const StudyDetailList = (props: StudyDetailList): JSX.Element => {
  if (props?.value?.value == '') return <></>;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignSelf: 'flex-start' }}>
      <UiText size="caption">
        <Text field={props?.label} />
      </UiText>
      <UiText size="body" bold color="black">
        <Text field={props?.value} />
      </UiText>
    </Box>
  );
};

export default StudyDetailList;
